import React from "react";
import Header from "../component/Home/Header";
import Footer from "../component/Home/Footer";
import MockTestCard from "../component/MockTest/MockTestCard";

const Tests = () => {
  return (
    <>
      <Header />
      <MockTestCard />
      <Footer />
    </>
  );
};

export default Tests;
